import * as React from 'react';

// A function that generates a random 8 digit number
const random8DigitNumber = () => Math.floor(Math.random() * 100000000);

const containerNumbers = ['FFAU3357015', 'HMCU9095368'];

export const ExampleTable: React.FC = () => {
  return (
    <table className="bg-white my-6">
      <thead>
        <tr className="border border-gray-200 py-1 font-medium">
          <td className="py-1 px-2 w-52">Ocean BOL (required)</td>
          <td className="py-1 px-2 w-52">Ocean SCAC (optional)</td>
          <td className="py-1 px-2 w-52">Container # (optional)</td>
          <td className="py-1 px-2 w-52">Reference ID (optional)</td>
        </tr>
      </thead>
      <tbody>
        {Array.from(Array(2), (_, i) => (
          <tr key={i} className="border border-gray-200">
            <td className="p-2 w-52">COSU{random8DigitNumber()}</td>
            <td className="p-2 w-52">COSU</td>
            <td className="p-2 w-52">{containerNumbers[i]}</td>
            <td className="p-2 w-52">Acme</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
ExampleTable.displayName = 'BulkUpload.Example.ExampleTable';
